import locales_pl from 'locales/pl.json';
import locales_en from 'locales/en.json';

const useMessages = () => {
  return {
    pl: locales_pl,
    en: locales_en,
  };
};

export default useMessages;
